import { Component, OnInit } from '@angular/core';

import { CommonDataService } from './shared/catalogue/services/common-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'ITI Mutual Fund Admin Console';
  loaderStatus = false;

  constructor(
    public commonDataService: CommonDataService) {
      this.commonDataService.loaderStatus.asObservable().subscribe((data) => {
        setTimeout(() => {
          this.loaderStatus = data;
     });
    });
  }

  ngOnInit() {
  }
}
